/**
 * Use this file for JavaScript code that you want to run in the front-end
 * on posts/pages that contain this block.
 *
 * When this file is defined as the value of the `viewScript` property
 * in `block.json` it will be enqueued on the front end of the site.
 *
 * Example:
 *
 * ```js
 * {
 *   "viewScript": "file:./view.js"
 * }
 * ```
 *
 * If you're not making any changes to this file because your project doesn't need any
 * JavaScript running in the front-end, then you should delete this file and remove
 * the `viewScript` property from `block.json`.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/block-api/block-metadata/#view-script
 */


document.addEventListener('DOMContentLoaded', function() {
    setTimeout(function() {
        document.getElementById('uni_popup-overlay').style.display = 'flex';
    }, 4000);

    document.getElementById('uni_promo-popup-close').addEventListener('click', function() {
        document.getElementById('uni_popup-overlay').style.display = 'none';
    });
});

document.addEventListener('DOMContentLoaded', () => {
  const timerEl = document.getElementById('popup-timer');
  if ( ! timerEl ) return; 

  const initialMinutes = parseInt(timerEl.dataset.minutes, 10) || 0;
  const deadline       = Date.now() + initialMinutes * 60000;
  let intervalId;

  function updateTimer() {
    const diff = deadline - Date.now();
    if ( diff <= 0 ) {
      timerEl.textContent = '00:00';
      clearInterval(intervalId);
      return;
    }
    const mm = String(Math.floor(diff / 60000)).padStart(2, '0');
    const ss = String(Math.floor((diff % 60000) / 1000)).padStart(2, '0');
    timerEl.textContent = mm + ':' + ss;
  }

  updateTimer();
  intervalId = setInterval(updateTimer, 1000);
});
